import { useState } from 'react';
import { useTranslation } from '@klv/hooks/useTranslation';

import Icon from '@klv/atoms/icon';
import { generateClassName } from '@klv/shared/utils/functions';

import DemoForm from './form';
import DemoSuccess from './success';
import FormWrapper from '../wrapper';
import HubSpotDemoForm from './hubSpotDemoForm';
import * as styles from '../styles/forms.module.scss';

import type { IDemoFormIndex } from '../types';

const Demo = ({
  backgroundColor = 'light',
  bodyCopy = '',
  formState,
  headline = '',
  inHero = false,
  setFormState,
  settings,
  templateName,
  demoType,
  demoFormHeader,
  demoFormRedirectUrl,
}: IDemoFormIndex) => {
  const { t } = useTranslation();
  const [success, setSuccess] = useState(false);
  const colorVariant = 'light';
  let plaintextHeadline =  t('organisms_forms_demo_headline');
  let body = t('organisms_forms_demo_body');
  // removes <p> tags from the demoFormHeader
  const strippedDemoHeaderHtml = demoFormHeader ? demoFormHeader.replace(/<\/?p>/gi, '') : '';
  // override the default settings with the demoFormRedirectUrl if it exists
  const customizeSettings = demoFormRedirectUrl ? { ...settings, redirectUrl: demoFormRedirectUrl } : settings;
  if (inHero) {
    plaintextHeadline = t('organisms_forms_demo_headlineEmbedded');
    body = bodyCopy;
  }

  if (success) {
    return (
      <DemoSuccess
        colorVariant={colorVariant}
        templateName={templateName}
      />
    );
  }

  return (
    <FormWrapper
      backgroundColor={backgroundColor}
      inHero={inHero}
      logo={<Icon className={styles.logo} iconName="Logo" fillColor="currentColor" role="img" aria-label="Klaviyo Logo" />}
    >
      <header>
        {demoFormHeader ? ( 
          <h2 
            className={generateClassName(['h2', styles.headline])}
            dangerouslySetInnerHTML={{ __html: strippedDemoHeaderHtml }}
          /> ) : (
          <h2 
            className={generateClassName(['h2', styles.headline])}
            dangerouslySetInnerHTML={headline ? { __html: headline } : undefined}
          >
            {headline ? null : plaintextHeadline}
          </h2>)
        }
        {body && (
          <p 
            className={generateClassName(['p1', styles.marginBottom25])}
            dangerouslySetInnerHTML={{ __html: body }}
          />
        )}
      </header>
      <div className="formSmall" >{t('organisms_forms_demo_allRequired')}</div>
      {demoType === 'demoHubSpot' ? (
        <HubSpotDemoForm
          backgroundColor={backgroundColor}
          setSuccess={setSuccess} 
          settings={customizeSettings || {}} 
          />) : (
        <DemoForm
          backgroundColor={backgroundColor}
          formState={formState}
          setFormState={setFormState}
          setSuccess={setSuccess}
          settings={settings}
          templateName={templateName}
        />
      )}
  
    </FormWrapper>
  );
};

export default Demo;
